import {API, Setup} from '../../Services';


async function clothing_cats(merchantId){
    const token = localStorage.getItem('token')
    return API.get(`/shop/${merchantId}/product_category/?parent__isnull=true`,{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}

async function clothing_merchant(merchantId){
    const token = localStorage.getItem('token')
    return API.get(`/merchants/public/${merchantId}`);
}

async function clothing_search(merchantId, search,page=1,sort,startPrice,endPrice,available,brands=""){
    let token =  localStorage.getItem('token');
    return API.get(`/shop/${merchantId}/product/?search=${search}&page=${page}&${sort}&is_available=${available}${brands}`,
        {headers:
                { 'Authorization':  `Bearer ${token}`}
        });
}



async function clothing_products(merchantId,catId,page,search="",sort){
    const token = localStorage.getItem('token')
    return API.get(`/shop/${merchantId}/product-public/?search=${search}&page=${page}&${sort}&category__uid=${catId}`);
}

async function clothing_product(merchantId,productId){
    const token = localStorage.getItem('token')
    return API.get(`/shop/${merchantId}/product/${productId}`);
}




async function clothing_like(productId){
    const token = localStorage.getItem('token')
    return API.post(`/like/product/uid/${productId}/`,{},{
        headers: { 'Authorization':  `Bearer ${token}`}
    });
}


export {
    clothing_cats,
    clothing_like,
    clothing_products,
    clothing_product,
    clothing_search,
    clothing_merchant
};
